module.exports = __webpack_public_path__ + "img/homepage-location.135e9370.png";